import React, { useState } from "react";
import AddIcon from '@mui/icons-material/Add';
// import Fab from '@mui/material/Fab';


function CreateArea(props) {
  const [note, setNote] = useState({
    title: "",
    content: ""
  });
  function handleNote(event) {
    const { name, value } = event.target;
    setNote((prev) => {
      return {
        ...prev,
        [name]: value
      };
    });
  }
  function handleClick(event) {
    props.onAdd(note);
    setNote({
      title: "",
      content: ""
    });
    event.preventDefault();
  }

  return (
    <div>
      <form>
        <input
          onChange={handleNote}
          name="title"
          placeholder="Title"
          value={note.title}
        />
        <textarea
          onChange={handleNote}
          name="content"
          placeholder="Take a note..."
          rows="3"
          value={note.content}
        />
        <button onClick={handleClick}><AddIcon/></button>
      </form>
    </div>
  );
}

export default CreateArea;
